import { CustomerPortalCurrentUser } from '~/modules/settings/_state/customerPortalUserForm.state';
import { createQueryHook } from '~/shared/providers/api';

export interface CustomerPortalUserQueryParams {
  invitationId: string;
}

export interface CustomerPortalUserQueryResult {
  invitation: CustomerPortalCurrentUser | null;
}

export const useCustomerPortalUserQuery = createQueryHook(
  'settings.customerPortal.user',
  (params: CustomerPortalUserQueryParams) => ({
    customerInvitations: {
      __args: {
        filter: {
          invitationIds: [params.invitationId],
          includeAccount: true,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        email: true,
        invitationStatus: true,
        accountId: true,
        sentAt: true,
        acceptedAt: true,
        account: {
          id: true,
          name: true,
        },
      },
    },
  }),
  {
    select: (data): CustomerPortalUserQueryResult => {
      const inv = data?.customerInvitations?.entries?.[0];
      if (!inv) return { invitation: null };

      const isAccepted = inv.invitationStatus?.toLowerCase() === 'accepted';

      return {
        invitation: {
          id: inv.id,
          firstName: '',
          lastName: '',
          email: inv.email,
          phone: null,
          company: inv.account?.name ?? '',
          contactLocation: '',
          status: isAccepted ? 'active' : 'invite_sent',
          accountId: inv.accountId,
          createdAt: inv.sentAt ?? '',
        },
      };
    },
  },
);
